<template>
    <div :class="['page account',{ off: !pageOn }]">
        <VHeader type="back" @back="back" />
        <div class="page-content">
            <div v-if="user" class="account-user">
                <p><span>Client</span>{{ user.client || 'Copper House' }}</p>
                <p><span>Name</span>{{ user.name }}</p>
                <p><span>Mobile</span>{{ user.prettyPhone }}</p>
            </div>
            <p class="btn" @click="logout">logout</p>
        </div> 
        <!--
        <Auth v-if="pages.indexOf('auth') > -1" />
        <MyAccount v-if="pages.indexOf('my-account') > -1" @exit="popPage('my-account')" />     
        -->     
    </div>
    
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { mapMutations } from 'vuex'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'

import Auth from '@/components/Auth.vue'
import Campaign from '@/components/Campaign.vue'
import MyAccount from '@/components/myAccount.vue'
import WebSoc from '@/utils/WebSoc.js'

export default {
    name: 'account',
    components: {
        VHeader,
        Auth,
        Campaign,
        MyAccount
    },
    mixins: [ pageOn ],
    computed: {
        auth () { return this.$store.state.auth },
        pages () { return this.$store.state.pages },
    },
    data () {
        return {
            campaign_id: '',
            showAccount: false,
            user: false
        }
    },
    mounted () {
        console.log('Account.vue',this.auth);
        if ( !this.auth ) return this.setPages(['auth']);
        WebSoc.SEND({ t: 'getClientUserAccount', data: { auth: this.auth }},resp => {
            console.log('getClientUserAccount resp',resp);
            this.user = resp.user;
        });
    },
    methods: {
        logout () {
            console.log('logout auth',this.auth);
            WebSoc.SEND({ t: 'loyaltyClientLogout', data: { auth: this.auth }},resp => {
                console.log('logout resp',resp);
                    try {
                        ['loyalty_id','loyaltyId'].forEach(key => localStorage.removeItem(key));
                    } catch(e) {};
                    this.setAuth(false);
                    this.setPages(['auth']);
                    this.back();
                    Alert.message('Logout Successful',2000);
                })
        },
        back () {
            this.pageOn = false;
        },
        ...mapMutations(['pushPage','popPage','setAuth','setPages'])
    }
}

</script>

<style lang="scss">
.account-user {
    text-align: center;
    > p {
        margin: 10px 0px;
        line-height: 2;
        padding: 10px 0px;
        font-size: 30px;
        span { width: 100%; float: left; font-size: 25px; }
    }
}
</style>